module.exports = __webpack_public_path__ + "files/418055d07ed9e88396ef5479ef3480da.png";